<template>
  <div class="my-stepper">
    <van-stepper v-model="isValue" :input-width="`${inputWidth}px`" :max="max" :button-size="`${{buttonSize}}px`"/>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    inputWidth: {
      type: String,
      default: "30",
    },
    buttonSize: {
      type: String,
      default: "22",
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  watch: {
    isValue(val) {
      this.$emit("input", val);
    },
  },
  name: "MyStepper",
  data() {
    return {
      isValue: this.value,
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-stepper__minus {
  border-radius: 10px 0 0px 10px;
  background-color: #ffffff;
}

::v-deep .van-stepper__plus {
  border-radius: 0 10px 10px 0;
  background-color: #ffffff;
}
::v-deep .van-stepper__input {
  background-color: #ffffff;
}
</style>
